'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = composeDecorators;

var _constants = require('./constants');

var _makeDecoratedComponent = require('./makeDecoratedComponent');

var _makeDecoratedComponent2 = _interopRequireDefault(_makeDecoratedComponent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function applyCompose(decorator) {
  return decorator(_constants.COMPOSING);
}

function composeDecorators() {
  for (var _len = arguments.length, partialDecorators = Array(_len), _key = 0; _key < _len; _key++) {
    partialDecorators[_key] = arguments[_key];
  }

  return _makeDecoratedComponent2["default"].bind(null, partialDecorators.map(applyCompose));
}